import { IGetWallet } from '@tacans/shared-marketplace-layer';
import { useWallets } from 'src/features/common/wallet/hooks/wallet.hooks';

export const useMyWalletsById = () => {
    const wallets = useWallets();

    return wallets.reduce((acum, wallet) => {
        acum[wallet.address] = wallet;
        return acum;
    }, {} as Record<string, IGetWallet>);
};
